import styled from 'styled-components'

import CAcceptTerms from './AcceptTerms'
import CFullForm from './FullForm'
import CCompleted from './Completed'

export const Container = styled.div<{ $background: string }>`
  background-image: url(${(props) => props.$background});
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  width: 100%;
`

export const AcceptTerms = styled(CAcceptTerms)``

export const FullForm = styled(CFullForm)``

export const Completed = styled(CCompleted)``
